import { render, staticRenderFns } from "./DCIInputForm.vue?vue&type=template&id=01023b72&scoped=true"
import script from "./DCIInputForm.vue?vue&type=script&lang=js"
export * from "./DCIInputForm.vue?vue&type=script&lang=js"
import style0 from "./DCIInputForm.vue?vue&type=style&index=0&id=01023b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01023b72",
  null
  
)

export default component.exports